
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
const fileBaseUrl = runEvn().fileBaseUrl;
import runEvn from "../../../modular/runEvn/RunEvn";

const Take_Order = "Take_Order";
const View_Detail = "View_Detail";

const Order_Edit = "Order_Edit";//编辑
const Order_Finish = "Order_Finish";//完成
const Order_Refresh = "Order_Refresh";//发布
const Order_Detele = "Order_Detele";//删除

// const Order_Comfin_Republish = "Order_Comfin_Republish";//重新发布 button
// const Order_Comfin_Finish = "Order_Comfin_Finish";//我已完成 button
const Contacts_Btn = "Contacts_Btn";
const Contacts_Cancel_Btn = "Contacts_Cancel_Btn";

export default defineComponent({
  setup() {
    const router = useRouter();
    return {
      router,
      Take_Order,
      View_Detail,
      Order_Edit,
      Order_Finish,
      Order_Refresh,
      Order_Detele,
      Contacts_Btn,
      Contacts_Cancel_Btn,
    };
  },
  data() {
    return {};
  },
  name: "HelpWithLoveItem",
  components: {},
  props: {
    //数据
    itemData: {
      type: Object,
      default: {} as any
    },
    isHomePage: {
      type: Boolean,
      default() {
        return true;
      },
    } as any,
  },
  computed: {
    headTitle() {
      return "";
    },

  },
  methods: {
    goDetails() {
      this.router.push({
        path: `/mulin/mutualAid/Details/${this.itemData.id}`,
        query: {
          helpActType: 2,
        },
      });
    },
    format(time, string) {
      return new Date(time).format(string);
    },
    onClick(id, msg, data: any) {
      this.$emit("onHelpWithLoveItemResult", id, msg, data);
    },
    getWhiteButtonLabel(index) {
      let arr;
      if (this.itemData.helpStatus == 1) {
        arr = ["编辑", "刷新", "取消"];
      }
      else if (this.itemData.helpStatus == 2) {
        arr = ["编辑", "刷新", "取消"];
      } else if (this.itemData.helpStatus == 3) {
        arr = ["确认完成", "刷新", "取消"];
      } else if (this.itemData.helpStatus == 5) {
        arr = ["编辑", "刷新", "取消"];
      } else if (this.itemData.helpStatus == 8) {
        arr = ["编辑", "刷新", "取消"];
      } else {
        arr = ["", "", ""];
      }
      let result = arr[index];
      return result;
    },
    getWhiteButtonIcon(index) {
      let src;
      if (this.itemData.helpStatus == 1) {
        src = [
          require("@/assets/image/icon_order_edit.png"),
          require("@/assets/image/icon_order_refresh.png"),
          require("@/assets/image/icon_order_delete.png"),
        ];
      } else if (this.itemData.helpStatus == 2) {
        src = [
          require("@/assets/image/icon_order_finish.png"),
          require("@/assets/image/icon_order_refresh.png"),
          require("@/assets/image/icon_order_delete.png"),
        ];
      } else if (this.itemData.helpStatus == 3) {
        src = [
          require("@/assets/image/icon_order_edit.png"),
          require("@/assets/image/icon_order_refresh.png"),
          require("@/assets/image/icon_order_delete.png"),
        ];
      } else if (this.itemData.helpStatus == 5) {
        src = [
          require("@/assets/image/icon_order_edit.png"),
          require("@/assets/image/icon_order_refresh.png"),
          require("@/assets/image/icon_order_delete.png"),
        ];
      } else if (this.itemData.helpStatus == 8) {
        src = [
          require("@/assets/image/icon_order_edit.png"),
          require("@/assets/image/icon_order_refresh.png"),
          require("@/assets/image/icon_order_delete.png"),
        ];
      } else {
        src = ["", "", ""];
      }
      let result = src[index];
      return result;
    },
    getWhiteButtonMsg() {
      let Str;
      if (this.itemData.helpStatus == 1) {
        Str = Order_Edit;
      }
      else if (this.itemData.helpStatus == 2) {
        Str = Order_Edit;
      } else if (this.itemData.helpStatus == 3) {
        Str = Order_Finish;
      } else if (this.itemData.helpStatus == 5) {
        Str = Order_Edit;
      }
      else if (this.itemData.helpStatus == 8) {
        Str = Order_Edit;
      } else {
        Str = "";
      }
      let result = Str;
      return result;
    },
    img(key: string) {
      return fileBaseUrl + key;
    },
  },
});
